import { render, staticRenderFns } from "./GLAccount.vue?vue&type=template&id=642c5da4"
import script from "./GLAccount.vue?vue&type=script&lang=js"
export * from "./GLAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports